"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _utils = require("../../shared/utils");
var _theme = _interopRequireDefault(require("../../theme"));
var _H = require("./H1");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var A = /*#__PURE__*/
(0, _reactEmotion.default)('a', {
  target: "e16rbysa0"
})(_base.default, ";", _font.default, ";", _H.text, " text-decoration:none;color:", function (props) {
  return (0, _utils.getProperty)(props, 'primaryColor');
}, ";margin:", function (props) {
  return props.margin || '0';
}, ";font-size:", function (props) {
  return props.fontSize || '0.9rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '1.1rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 'normal';
}, ";cursor:pointer;transition:all 0.3s ease;&:hover,&:focus{color:", function (props) {
  return props.theme.primaryColor ? (0, _utils.shade)(props.theme.primaryColor, -0.2) : (0, _utils.shade)(_theme.default.primaryColor, -0.2);
}, ";}");
var _default = A;
exports.default = _default;